import useRequest from "~/hooks/use-request";

const PosterAPI = {
  load(options?: IRequestPaginatedParams): Promise<IModelPoster[]> {
    const { request } = useRequest();

    const formatPoster = (data: IResponsePoster) => ({
      imageUrl: data.url,
      linkUrl: data.link,
      linkTarget: data.target,
    });

    const defaultParams = {
      platform: "web",
    };

    const params = Object.assign({}, defaultParams, options);
    return request
      .get<IContentResponse<IResponsePoster[]>>("/api/resources/posters", { query: params })
      .then(response => response.content.map(formatPoster));
  },
};

export default PosterAPI;
